import { Button, ButtonProps, HStack, IconButton, Link } from "@chakra-ui/react"
import { useColorModeValue } from "@pathwright/ux/src/components/chakra/ui/color-mode"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { useState } from "react"
import getPWAdminSSOUrl, {
  getPWAdminSSOOptions,
  removePWAdminSSOOption
} from "../utils/getPWAdminSSOUrl"

function PWAdminSSOAuthMethods(props: ButtonProps) {
  // Lazy, for now, just ticking when need to rerender (but should probably use a local storage hook).
  const [tick, setTick] = useState(0)
  // Allow pw admin sso in local dev by default.
  const defaultOptions = process.env.NODE_ENV === "development" ? [""] : []
  const options = getPWAdminSSOOptions() || defaultOptions
  // Only show the first option for now, which is the default "admin::" for authenticating
  // as one's self. Handling the other options via the pw admin command menu for now.
  const filteredOptions = options.slice(0, 1)

  const colorPalette = useColorModeValue("brand", undefined)

  // Click handler that prevents the default navigation if the meta key is pressed.
  // In that case, we prompt the user for a proxy username/email and use that to
  // construct the SSO URL.
  const handleLink = (event: React.MouseEvent) => {
    if (event.metaKey) {
      event.preventDefault()
      const proxyUser = prompt("Enter the username/email to proxy into:")
      // If proxyEmail is null, then login action was canceled.
      if (proxyUser !== null) {
        window.location.href = getPWAdminSSOUrl(`admin::${proxyUser || ""}`)
      }
    }
  }

  const handleRemove = (targetUser: string) => {
    if (targetUser) {
      removePWAdminSSOOption(targetUser)
      setTick((prev) => prev + 1)
    }
  }

  return filteredOptions.map((option) => (
    <HStack
      className="group"
      key={option}
      w="100%"
      gap={1}
      pos="relative"
      // Odd way to remove text decor while preserving default hover effects,
      // which surprisingly get removed when applying _hover directly to Button.
      css={{
        _hover: {
          "& *": {
            textDecor: "none"
          }
        }
      }}
    >
      <Button
        asChild
        variant="solid"
        colorPalette={colorPalette}
        onClick={handleLink}
        w="100%"
        {...props}
      >
        <Link href={getPWAdminSSOUrl(`admin::${option}`)}>
          <Pathicon icon="avatar-lock" />
          {option ? `PW Admin::${option}` : "PW Admin"}
        </Link>
      </Button>
      {!!option && (
        <IconButton
          aria-label={`Remove login option for ${option}`}
          children={<Pathicon icon="x" />}
          colorPalette={colorPalette}
          onClick={() => handleRemove(option)}
          pos="absolute"
          right="0"
          display="none"
          _groupHover={{
            display: "block"
          }}
        />
      )}
    </HStack>
  ))
}

export default PWAdminSSOAuthMethods
